<template>
  <div class="content" id="order-edit">
    <h1>{{ pageTitle }}</h1>
    <div class="content-body two-columns form-wrapper">
      <div class="left">
        <div class="block">
          <OrderForm :order-data="orderData" :after-saved="handleOrderSaved" :current-user="currentUser"></OrderForm>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { OrderForm } from './forms'
export default {
  name: 'OrderNew',
  components: {
    OrderForm
  },
  computed: {
    ...mapGetters(['currentUser']),
    pageTitle () {
      document.title = this.$t('menu.order.new')
      return document.title
    }
  },
  data () {
    return {
      orderData: {}
    }
  },
  methods: {
    handleOrderSaved (order) {
      this.$router.push({ name: 'menu.order.detail', params: { id: order.id } })
    }
  }
}
</script>
